import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceHigh: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVoiceHigh"><Path fillRule="evenodd" clipRule="evenodd" d="M9 3V21H7V3H9ZM17 5V19H15V5H17ZM13 7V17H11V7H13ZM5 9V15H3V9H5ZM21 9V15H19V9H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceHigh;
